// تعريف باقات «راصد حضوري» الأربع — المصدر الوحيد للأسماء والأسعار والتدرج في الواجهة
export const PLAN_ORDER = ["trial", "basic", "premium", "semester", "year"];

export const PLANS = {
  trial: { name: "اشتراك تجريبي", price: 0, priceLabel: "مجاناً", duration: "3 أيام — كل الميزات" },
  basic: { name: "الأساسية", price: 50, priceLabel: "50 ريال", duration: "فصل دراسي" },
  premium: { name: "البريميوم", price: 100, priceLabel: "100 ريال", duration: "فصل دراسي" },
  semester: { name: "الشاملة (فصل دراسي)", price: 150, priceLabel: "150 ريال", duration: "فصل دراسي" },
  year: { name: "الشاملة (عام دراسي)", price: 250, priceLabel: "250 ريال", duration: "عام دراسي كامل" },
};

// أدنى باقة تُتاح فيها الميزة
export const FEATURE_MIN_PLAN = {
  portal: "premium",
  circulars: "premium",
  permissions: "premium",
  audit: "premium",
  performance: "semester",
};

export const FEATURE_LABELS = {
  portal: "بوابة الموظفين",
  circulars: "التعاميم",
  permissions: "الصلاحيات",
  audit: "سجل التدقيق",
  performance: "تقييم الأداء الوظيفي",
};

export const userHasFeature = (user, feature) => {
  if (!user || user.role === "admin") return true;
  const plan = user.plan;
  if (plan === "trial") return true; // الفترة التجريبية بكل الميزات
  const min = FEATURE_MIN_PLAN[feature];
  if (!min) return true;
  return PLAN_ORDER.indexOf(plan) >= PLAN_ORDER.indexOf(min);
};

// المستخدم المنتهي اشتراكه (يُقيَّد كل شيء عدا «اشتراكي» و«الدعم»)
export const isExpiredUser = (user) => {
  if (!user || user.role === "admin") return false;
  if (user.plan_status === "expired") return true;
  return !!user.subscription_end && new Date(user.subscription_end) < new Date();
};

// صفوف جدول المقارنة: [التسمية, trial, basic, premium, semester, year]
export const COMPARISON_ROWS = [
  ["سجل الحضور والانصراف (الاستيراد والتقارير)", true, true, true, true, true],
  ["إدارة بيانات الموظفين", true, true, true, true, true],
  ["المساءلات وقرارات الحسم (توليد وطباعة)", true, true, true, true, true],
  ["إضافة كروم للاستيراد التلقائي", true, true, true, true, true],
  ["إرسال المساءلات للموظفين عبر البوابة", true, false, true, true, true],
  ["بوابة الموظفين (رمز المدرسة والتفعيل)", true, false, true, true, true],
  ["التعاميم", true, false, true, true, true],
  ["الصلاحيات", true, false, true, true, true],
  ["سجل التدقيق", true, false, true, true, true],
  ["تقييم الأداء الوظيفي", true, false, false, true, true],
];
